import { Badge, Stack, Typography } from '@mui/material'

interface Props {
  number: number
  label: string
  color: string
  disabled?: boolean
}

export function NumberedLabel(props: Props) {
  const { number, label, color, disabled } = props

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Badge
        badgeContent={number}
        sx={{
          '& .MuiBadge-badge': {
            bgcolor: disabled ? 'action.disabledBackground' : color,
            color: disabled ? 'text.disabled' : 'white',
            position: 'relative',
            transform: 'none',
            minWidth: 24,
            height: 24,
            borderRadius: '50%',
            fontSize: '0.875rem',
            fontWeight: 600,
          },
        }}
      />
      <Typography variant="body2" color={disabled ? 'text.disabled' : 'text.primary'}>
        {label}
      </Typography>
    </Stack>
  )
}
